import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const initialState = {
    isLoading: false,
    data: [],
    isError: false,
};

export const fetchNcdDataList = createAsyncThunk('fetchNcdDataList', async () => {
    const response = await fetch(`${API_BASE_URL}/NCD_Data/list`, {
        method: 'GET',
        headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
    });
    return response.json();
});

export const deleteNCD = createAsyncThunk('deleteNCD', async ({id}, {dispatch}) => {
    const details = {
        'memo_id': id,
    };

    let formBody = [];
    for (let property in details) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    
    const response = await fetch(`${API_BASE_URL}/NCD_Data/delete`, {
        method: 'POST',
        headers: { 
            'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody
    });
    dispatch(fetchNcdDataList());
    return response.json(); 
});

const ncdDataSlice = createSlice({
    name: 'ncdData',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchNcdDataList.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchNcdDataList.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload.data) {
                state.data = action.payload.data;
            } else {
                state.isError = true;
            }
        });
        builder.addCase(fetchNcdDataList.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
        })
    }
});

export default ncdDataSlice;
